import React from 'react';
import Footer from '../Footer';
import { withStyles } from '@material-ui/core';

const styles = {
  root: {
    paddingBottom: '3em',
    paddingTop: '60px !important'
  }
};

class NavigationLayout extends React.Component {
  render() {
    const { classes, children } = this.props;
    return (
      <div className={classes.root}>
        {children}
        <Footer />
      </div>
    );
  }
}

export default withStyles(styles)(NavigationLayout);
